// import React, { useState } from 'react';
// import axios from 'axios';
// import './SuiteManagement.css';

// const API_URL =  'https://apitop.topranohotelandlounge.com';

// const SuiteManagement = ({ suiteTypes, onUpdate }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     description: '',
//     basePrice: '',
//     capacity: '',
//     size: '',
//     totalRooms: '',
//     images: '',
//     amenities: '',
//   });
//   const [editingSuite, setEditingSuite] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage('');
//     setError('');

//     try {
//       const payload = {
//         ...formData,
//         basePrice: parseFloat(formData.basePrice),
//         capacity: parseInt(formData.capacity, 10),
//         totalRooms: parseInt(formData.totalRooms, 10),
//         images: formData.images ? formData.images.split(',').map((img) => img.trim()) : [],
//         amenities: formData.amenities ? formData.amenities.split(',').map((amenity) => amenity.trim()) : [],
//       };

//       if (editingSuite) {
//         await axios.put(`${API_URL}/api/suite-types/${editingSuite._id}`, payload);
//         setMessage('Suite type updated successfully!');
//       } else {
//         // Placeholder for create functionality (not implemented yet)
//         throw new Error('Create functionality not implemented');
//       }
//       setFormData({
//         name: '',
//         description: '',
//         basePrice: '',
//         capacity: '',
//         size: '',
//         totalRooms: '',
//         images: '',
//         amenities: '',
//       });
//       setEditingSuite(null);
//       onUpdate('Suite type updated successfully!');
//     } catch (error) {
//       console.error('Error saving suite type:', error);
//       setError(error.response?.data?.message || 'Failed to save suite type');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (suite) => {
//     setFormData({
//       name: suite.name,
//       description: suite.description,
//       basePrice: suite.basePrice,
//       capacity: suite.capacity,
//       size: suite.size,
//       totalRooms: suite.totalRooms,
//       images: suite.images.join(', '),
//       amenities: suite.amenities.join(', '),
//     });
//     setEditingSuite(suite);
//     setMessage('');
//     setError('');
//   };

//   if (!suiteTypes) {
//     return <div className="suite-management">Loading suites...</div>;
//   }

//   return (
//     <div className="suite-management">
//       <div className="admin-form">
//         <h2 className="form-title">{editingSuite ? 'Edit Suite Type' : 'Create Suite Type'}</h2>
//         {message && <div className="alert alert-success">{message}</div>}
//         {error && <div className="alert alert-error">{error}</div>}
//         <form onSubmit={handleSubmit} className="form-container">
//           <div className="form-group">
//             <label htmlFor="name">Suite Name</label>
//             <input
//               type="text"
//               id="name"
//               placeholder="Enter suite name"
//               value={formData.name}
//               onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//               className="form-input"
//               required
//             />
//           </div>
//           <div className="form-group">
//             <label htmlFor="description">Description</label>
//             <textarea
//               id="description"
//               placeholder="Enter suite description"
//               value={formData.description}
//               onChange={(e) => setFormData({ ...formData, description: e.target.value })}
//               className="form-textarea"
//               required
//               rows="4"
//             />
//           </div>
//           <div className="form-grid">
//             <div className="form-group">
//               <label htmlFor="basePrice">Base Price (NGN)</label>
//               <input
//                 type="number"
//                 id="basePrice"
//                 placeholder="Enter base price"
//                 value={formData.basePrice}
//                 onChange={(e) => setFormData({ ...formData, basePrice: e.target.value })}
//                 className="form-input"
//                 required
//                 min="0"
//                 step="0.01"
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="capacity">Capacity (Adults)</label>
//               <input
//                 type="number"
//                 id="capacity"
//                 placeholder="Enter capacity"
//                 value={formData.capacity}
//                 onChange={(e) => setFormData({ ...formData, capacity: e.target.value })}
//                 className="form-input"
//                 required
//                 min="1"
//               />
//             </div>
//           </div>
//           <div className="form-grid">
//             <div className="form-group">
//               <label htmlFor="size">Size (sq ft)</label>
//               <input
//                 type="text"
//                 id="size"
//                 placeholder="Enter size"
//                 value={formData.size}
//                 onChange={(e) => setFormData({ ...formData, size: e.target.value })}
//                 className="form-input"
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="totalRooms">Total Rooms</label>
//               <input
//                 type="number"
//                 id="totalRooms"
//                 placeholder="Enter total rooms"
//                 value={formData.totalRooms}
//                 onChange={(e) => setFormData({ ...formData, totalRooms: e.target.value })}
//                 className="form-input"
//                 required
//                 min="1"
//               />
//             </div>
//           </div>
//           <div className="form-group">
//             <label htmlFor="images">Images (comma-separated URLs)</label>
//             <input
//               type="text"
//               id="images"
//               placeholder="Enter image URLs"
//               value={formData.images}
//               onChange={(e) => setFormData({ ...formData, images: e.target.value })}
//               className="form-input"
//             />
//           </div>
//           <div className="form-group">
//             <label htmlFor="amenities">Amenities (comma-separated)</label>
//             <input
//               type="text"
//               id="amenities"
//               placeholder="Enter amenities"
//               value={formData.amenities}
//               onChange={(e) => setFormData({ ...formData, amenities: e.target.value })}
//               className="form-input"
//             />
//           </div>
//           <div className="form-buttons">
//             <button
//               type="submit"
//               disabled={loading}
//               className="btn btn-teal"
//             >
//               {loading ? 'Saving...' : editingSuite ? 'Update Suite Type' : 'Create Suite Type'}
//             </button>
//             {editingSuite && (
//               <button
//                 type="button"
//                 onClick={() => {
//                   setFormData({
//                     name: '',
//                     description: '',
//                     basePrice: '',
//                     capacity: '',
//                     size: '',
//                     totalRooms: '',
//                     images: '',
//                     amenities: '',
//                   });
//                   setEditingSuite(null);
//                 }}
//                 className="btn btn-secondary"
//               >
//                 Cancel
//               </button>
//             )}
//           </div>
//         </form>
//       </div>
//       <div className="list-container">
//         <h2 className="list-title">All Suite Types ({suiteTypes.length})</h2>
//         {suiteTypes.length === 0 ? (
//           <p className="no-suites">No suite types found. Create your first suite type!</p>
//         ) : (
//           suiteTypes.map((suite) => (
//             <div key={suite._id} className="list-item">
//               <div className="list-item-header">
//                 <h3 className="list-item-title">{suite.name}</h3>
//                 <div className="list-item-actions">
//                   <button
//                     onClick={() => handleEdit(suite)}
//                     className="btn btn-primary"
//                   >
//                     Edit
//                   </button>
//                 </div>
//               </div>
//               <p className="list-item-content">{suite.description}</p>
//               <div className="list-item-meta">
//                 <span>Price: ₦{suite.basePrice.toLocaleString()}</span>
//                 <span>Capacity: {suite.capacity} adults</span>
//                 <span>Size: {suite.size}</span>
//                 <span>Total Rooms: {suite.totalRooms}</span>
//                 <span>Available Rooms: {suite.availableRooms}</span>
//                 <span className={`badge ${suite.isAvailable ? 'badge-success' : 'badge-error'}`}>
//                   {suite.isAvailable ? 'Available' : 'Not Available'}
//                 </span>
//               </div>
//               {suite.images.length > 0 && (
//                 <div className="list-item-images">
//                   Images: {suite.images.join(', ')}
//                 </div>
//               )}
//               {suite.amenities.length > 0 && (
//                 <div className="list-item-amenities">
//                   Amenities: {suite.amenities.join(', ')}
//                 </div>
//               )}
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default SuiteManagement;









import React, { useState } from 'react';
import axios from 'axios';
import './SuiteManagement.css';

const API_URL = 'https://apitop.topranohotelandlounge.com';

const SuiteManagement = ({ suiteTypes, onUpdate }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    basePrice: '',
    capacity: '',
    size: '',
    totalRooms: '',
    images: '',
    amenities: '',
  });
  const [editingSuite, setEditingSuite] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const payload = {
        ...formData,
        basePrice: parseFloat(formData.basePrice),
        capacity: parseInt(formData.capacity, 10),
        totalRooms: parseInt(formData.totalRooms, 10),
        images: formData.images ? formData.images.split(',').map((img) => img.trim()) : [],
        amenities: formData.amenities ? formData.amenities.split(',').map((amenity) => amenity.trim()) : [],
      };

      if (editingSuite) {
        await axios.put(`${API_URL}/api/suite-types/${editingSuite._id}`, payload);
        setMessage('Suite type updated successfully!');
      } else {
        // Placeholder for create functionality (not implemented yet)
        throw new Error('Create functionality not implemented');
      }
      setFormData({
        name: '',
        description: '',
        basePrice: '',
        capacity: '',
        size: '',
        totalRooms: '',
        images: '',
        amenities: '',
      });
      setEditingSuite(null);
      onUpdate('Suite type updated successfully!');
    } catch (error) {
      console.error('Error saving suite type:', error);
      setError(error.response?.data?.message || 'Failed to save suite type');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (suite) => {
    setFormData({
      name: suite.name,
      description: suite.description,
      basePrice: suite.basePrice,
      capacity: suite.capacity,
      size: suite.size,
      totalRooms: suite.totalRooms,
      images: suite.images.join(', '),
      amenities: suite.amenities.join(', '),
    });
    setEditingSuite(suite);
    setMessage('');
    setError('');
  };

  if (!suiteTypes) {
    return <div className="suite-management">Loading suites...</div>;
  }

  return (
    <div className="suite-management">
      <div className="admin-form">
        <h2 className="form-title">{editingSuite ? 'Edit Suite Type' : 'Create Suite Type'}</h2>
        {message && <div className="alert alert-success">{message}</div>}
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit} className="form-container">
          <div className="form-group">
            <label htmlFor="name" className="form-label">Suite Name</label>
            <input
              type="text"
              id="name"
              placeholder="Enter suite name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="form-input"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="description" className="form-label">Description</label>
            <textarea
              id="description"
              placeholder="Enter suite description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="form-textarea"
              required
              rows="4"
            />
          </div>
          
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="basePrice" className="form-label">Base Price (₦)</label>
              <input
                type="number"
                id="basePrice"
                placeholder="Enter base price"
                value={formData.basePrice}
                onChange={(e) => setFormData({ ...formData, basePrice: e.target.value })}
                className="form-input"
                required
                min="0"
                step="0.01"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="capacity" className="form-label">Capacity (Adults)</label>
              <input
                type="number"
                id="capacity"
                placeholder="Enter capacity"
                value={formData.capacity}
                onChange={(e) => setFormData({ ...formData, capacity: e.target.value })}
                className="form-input"
                required
                min="1"
              />
            </div>
          </div>
          
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="size" className="form-label">Size (sq ft)</label>
              <input
                type="text"
                id="size"
                placeholder="Enter size"
                value={formData.size}
                onChange={(e) => setFormData({ ...formData, size: e.target.value })}
                className="form-input"
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="totalRooms" className="form-label">Total Rooms</label>
              <input
                type="number"
                id="totalRooms"
                placeholder="Enter total rooms"
                value={formData.totalRooms}
                onChange={(e) => setFormData({ ...formData, totalRooms: e.target.value })}
                className="form-input"
                required
                min="1"
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="images" className="form-label">Images (comma-separated URLs)</label>
            <input
              type="text"
              id="images"
              placeholder="https://example.com/image1.jpg, https://example.com/image2.jpg"
              value={formData.images}
              onChange={(e) => setFormData({ ...formData, images: e.target.value })}
              className="form-input"
            />
            <div className="input-hint">Separate multiple URLs with commas</div>
          </div>
          
          <div className="form-group">
            <label htmlFor="amenities" className="form-label">Amenities (comma-separated)</label>
            <input
              type="text"
              id="amenities"
              placeholder="Wi-Fi, Air Conditioning, TV, Mini Bar"
              value={formData.amenities}
              onChange={(e) => setFormData({ ...formData, amenities: e.target.value })}
              className="form-input"
            />
            <div className="input-hint">Separate amenities with commas</div>
          </div>
          
          <div className="form-buttons">
            <button
              type="submit"
              disabled={loading}
              className="btn btn-teal"
            >
              {loading ? 'Saving...' : editingSuite ? 'Update Suite Type' : 'Create Suite Type'}
            </button>
            {editingSuite && (
              <button
                type="button"
                onClick={() => {
                  setFormData({
                    name: '',
                    description: '',
                    basePrice: '',
                    capacity: '',
                    size: '',
                    totalRooms: '',
                    images: '',
                    amenities: '',
                  });
                  setEditingSuite(null);
                }}
                className="btn btn-secondary"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>
      
      <div className="list-container">
        <h2 className="list-title">All Suite Types ({suiteTypes.length})</h2>
        {suiteTypes.length === 0 ? (
          <div className="empty-state">
            <p>No suite types found. Create your first suite type!</p>
          </div>
        ) : (
          suiteTypes.map((suite) => (
            <div key={suite._id} className="list-item">
              <div className="list-item-header">
                <h3 className="list-item-title">{suite.name}</h3>
                <div className="list-item-actions">
                  <button
                    onClick={() => handleEdit(suite)}
                    className="btn btn-primary"
                  >
                    Edit
                  </button>
                </div>
              </div>
              <p className="list-item-content">{suite.description}</p>
              <div className="list-item-meta">
                <span className="meta-item">
                  <span className="meta-label">Price:</span> ₦{suite.basePrice.toLocaleString()}
                </span>
                <span className="meta-item">
                  <span className="meta-label">Capacity:</span> {suite.capacity} adults
                </span>
                <span className="meta-item">
                  <span className="meta-label">Size:</span> {suite.size}
                </span>
                <span className="meta-item">
                  <span className="meta-label">Total Rooms:</span> {suite.totalRooms}
                </span>
                <span className="meta-item">
                  <span className="meta-label">Available:</span> {suite.availableRooms}
                </span>
                <span className={`badge ${suite.isAvailable ? 'badge-success' : 'badge-error'}`}>
                  {suite.isAvailable ? 'Available' : 'Not Available'}
                </span>
              </div>
              {suite.images.length > 0 && (
                <div className="list-item-images">
                  <span className="meta-label">Images:</span> {suite.images.slice(0, 2).join(', ')}
                  {suite.images.length > 2 && <span> and {suite.images.length - 2} more</span>}
                </div>
              )}
              {suite.amenities.length > 0 && (
                <div className="list-item-amenities">
                  <span className="meta-label">Amenities:</span> {suite.amenities.slice(0, 3).join(', ')}
                  {suite.amenities.length > 3 && <span> and {suite.amenities.length - 3} more</span>}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SuiteManagement;